/**
 * @description 字典管理 dicManage
 * @author 系统生成
 * @date 2018/9/20
 */

import Logic from '../logic-base'

const dicManageBiz = new Logic()

dicManageBiz.findDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.findDic,
    data: data
  })
}

dicManageBiz.addDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.addDic,
    data: data
  })
}

dicManageBiz.amendDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.amendDic,
    data: data
  })
}

dicManageBiz.deleteDic = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.deleteDic,
    data: data
  })
}

dicManageBiz.deleteNewDictionary = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.deleteNewDictionary,
    data: data
  })
}

dicManageBiz.addNewDictionary = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.addNewDictionary,
    data: data
  })
}

dicManageBiz.updateNewDictionary = function (data) {
  return this.ajax({
    ...this.REQUEST_OPT.dicManage.updateNewDictionary,
    data: data
  })
}

export default dicManageBiz
